<template>
  <b-form-file multiple
    name="files"
    v-model="files"
    placeholder="Escollir fitxers"
    drop-placeholder="Deixa el fitxer aqui..."
  />
</template>

<script>

export default {
  data () {
    return {
      files: null
    }
  },
  watch: {
    files: function (newVal) {
      this.$emit('updateFiles', {
        files: newVal
      })
    }
  }
}
</script>

<style scoped>
</style>
